import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PlanForm from '../components/PlanForm';
import { useDispatch, useSelector } from 'react-redux';
import { cancelPlanCreate, editPlanRequest, fetchPlanById } from '../../api/plans/planSlice';

const PlanEditPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, isPlanEdited, selectedPlan } = useSelector((state) => state.plans);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(fetchPlanById(id));
    }
  }, [dispatch, id]);

  const handleUpdate = async (data) => {
    dispatch(editPlanRequest(data));
    return navigate('/plans');
  };

  function handleCancel() {
    dispatch(cancelPlanCreate());
    return navigate('/plans');
  }

  if (loading) {
    return null;
  }
  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 6 }}>
        Edit Plan
      </Typography>
      <PlanForm
        onSubmit={handleUpdate}
        onCancel={handleCancel}
        buttonText="Update"
        isEdit={true}
        initialData={selectedPlan ?? {}}
      />
    </Box>
  );
};

export default PlanEditPage;
